/**
 * External Dependencies, short list is needed on every page
 */

// import './libraries/SplitText.min';
import './components/nav';
import './components/anim';
import './components/modal';
import './components/lozad';
import './components/gallery';
import './components/accordion';
import './components/discovery';
import './components/vision-gallery';
import './components/lightgallery';
import './components/merch-carousel';
import './components/html-pdf';
import './components/entryForm';